import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=48a57910&scoped=true"
import script from "./CookieBar.vue?vue&type=script&lang=js"
export * from "./CookieBar.vue?vue&type=script&lang=js"
import style0 from "./CookieBar.vue?vue&type=style&index=0&id=48a57910&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a57910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a57910')) {
      api.createRecord('48a57910', component.options)
    } else {
      api.reload('48a57910', component.options)
    }
    module.hot.accept("./CookieBar.vue?vue&type=template&id=48a57910&scoped=true", function () {
      api.rerender('48a57910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/CookieBar.vue"
export default component.exports